module.exports = __webpack_public_path__ + "files/fffb18e3fc99ff883ff873ae1add626e.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-2.png
// module id = 1599
// module chunks = 60